/*
 * Fhanely: Fortschrittsbalken Gratisversand und Schalter-Upsells im Cart-Drawer.
 * Markup: snippets/fhanely-cart-progress.liquid und snippets/fhanely-cart-upsells.liquid.
 * Nach jeder Änderung wird der Drawer über das Theme-Ereignis "cart:change" neu gezeichnet.
 */

const fhanelyRoot = () => window.Shopify?.routes?.root || '/';

const fhanelyMoney = () =>
  new Intl.NumberFormat(window.Shopify?.locale || 'fr', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'EUR',
  });

// Warenkorb ändern und den Drawer (und alle anderen Warenkorb-Anzeigen des Themes) aktualisieren
async function fhanelyCartRequest(endpoint, body) {
  const sections = [];
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } })
  );

  const response = await fetch(`${fhanelyRoot()}cart/${endpoint}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ ...body, sections: sections.join(',') }),
  });
  const result = await response.json();
  if (!response.ok) throw new Error(result.description || result.message);

  // add.js liefert nur die neuen Zeilen, change.js den ganzen Warenkorb
  const cart = result.items && result.token ? result : await (await fetch(`${fhanelyRoot()}cart.js`)).json();
  cart.sections = result.sections;
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } })
  );
  return cart;
}

if (!customElements.get('fhanely-shipping-bar')) {
  customElements.define(
    'fhanely-shipping-bar',
    class extends HTMLElement {
      connectedCallback() {
        const rate = Number(window.Shopify?.currency?.rate) || 1; // Shopify liefert den Kurs als Text, z. B. "1.0"
        const threshold = Math.round(Number(this.getAttribute('threshold')) * rate);
        const total = Number(this.getAttribute('total'));
        const remaining = threshold - total;
        const progress = Math.max(0, Math.min(100, (total / threshold) * 100));

        // Den Text rendert Liquid im Format des Shops; nur bei anderer Währung (Wechselkurs) hier neu setzen
        const text = this.querySelector('.fsb__text');
        if (rate === 1) {
          // nichts zu tun
        } else if (remaining > 0) {
          const amount = document.createElement('strong');
          amount.textContent = fhanelyMoney().format(remaining / 100);
          const [before, after = ''] = this.dataset.unreached.split('[amount]');
          text.replaceChildren(before, amount, after);
        } else {
          text.textContent = this.dataset.reached;
        }
        this.classList.toggle('is-reached', remaining <= 0);
        this.querySelector('.fsb__track')?.setAttribute('aria-valuenow', Math.round(progress));

        // Der Drawer wird bei jeder Änderung neu gezeichnet: den Balken vom letzten Stand aus weiterlaufen lassen
        const fill = this.querySelector('.fsb__fill');
        fill.style.transition = 'none';
        fill.style.width = `${window.__fhanelyShippingProgress ?? 0}%`;
        requestAnimationFrame(() =>
          requestAnimationFrame(() => {
            fill.style.transition = '';
            fill.style.width = `${progress}%`;
          })
        );
        window.__fhanelyShippingProgress = progress;
      }
    }
  );
}

if (!customElements.get('fhanely-upsell')) {
  customElements.define(
    'fhanely-upsell',
    class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
      }

      onClick = async (event) => {
        event.preventDefault();
        if (this.busy) return;
        this.busy = true;

        const turnOn = !this.classList.contains('is-on');
        // Sofort umschalten, die Antwort zeichnet den Drawer danach mit echten Preisen neu
        this.classList.toggle('is-on', turnOn);
        this.classList.add('is-busy');
        this.querySelector('.fu-switch')?.setAttribute('aria-checked', String(turnOn));

        try {
          if (turnOn) {
            await fhanelyCartRequest('add', {
              items: [{ id: Number(this.dataset.variant), quantity: 1, properties: { _upsell: '1' } }],
            });
          } else {
            await fhanelyCartRequest('change', { id: this.dataset.lineKey, quantity: 0 });
          }
        } catch (error) {
          console.error('Fhanely Upsell:', error);
          this.classList.toggle('is-on', !turnOn);
          this.querySelector('.fu-switch')?.setAttribute('aria-checked', String(!turnOn));
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } finally {
          this.busy = false;
          this.classList.remove('is-busy');
        }
      };
    }
  );
}
